import profile from '../../Assets/Images/Artists/02/profile_hidden.jpg'
import projectOneImg1 from '../../Assets/Images/Artists/02/projects/01/1.jpg'
import projectOneImg2 from '../../Assets/Images/Artists/02/projects/01/2.jpg'
import projectOneImg3 from '../../Assets/Images/Artists/02/projects/01/3.jpg'

const projectOneImages = [
  projectOneImg1,
  projectOneImg2,
  projectOneImg3
]

const project1 = {
  title: 'untitled',
  year: 2017,
  content: [
    {
      type: 'image',
      images: [...projectOneImages]
    }
  ]
}

const projects = [
  project1,
]

const user = {
  username: 'buczy',
  name: 'Hussain H.',
  url: 'https://www.instagram.com/hamse3/',
  avatar: profile,
  anonymous: true,
  projects: projects
}

export default user



// WEBPACK FOOTER //
// ./src/Data/Users/buczy.js